import React, { useCallback, useContext, useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import { useParams, useSearchParams } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import {
  Alert,
  Box,
  Typography,
  Paper,
  Grid,
  Container,
  Divider,
} from "@mui/material";
import { getErrorResponse, getHeader, toastError } from "../../utils/util";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import RenderStatusMessage from "../../widgets/RenderStatusMessage";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import { UserContext } from "../../context/UserProvider";
import { GlassButton } from "../../themes/UiElements";

const RdMessageDetail = () => {
  const { id } = useParams();
  const { user, loading } = useContext(UserContext);
  const [searchParams] = useSearchParams();
  const rcsType = searchParams.get("isRcs");
  const [retrying, setRetrying] = useState(false);
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/message/get-message-detail/${id}?isRcs=${rcsType === "true"}`
  );

  const handleRetryQueued = useCallback(async () => {
    try {
      setRetrying(true);
      const response = await axios.post(
        `${API_ENDPOINT}/campaign/retry-message/${id}`,
        {},
        getHeader()
      );
      toast.success(response.data.message);
    } catch (error) {
      toastError(error);
    } finally {
      setRetrying(false);
    }
  }, [id]);

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  const message = data;
  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <Container maxWidth="md">
        <Paper variant="outlined" sx={{ p: 3, my: 2 }}>
          <PageTitle>Message Details</PageTitle>
          <Divider sx={{ my: 2 }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Customer ID:
              </Typography>
              <Typography>{message?.cusId}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Campaign Name:
              </Typography>
              <Typography>{message?.campaignName}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                To:
              </Typography>
              <Typography>{message.displayTo}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                From:
              </Typography>
              <Typography>{message.from}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" fontWeight="bold">
                Message Body:
              </Typography>
              <Typography sx={{ whiteSpace: "pre-wrap" }}>
                {message.body}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Template Name:
              </Typography>
              <Typography>{message.templateName}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Status:
              </Typography>
              <Typography>
                <RenderStatusMessage status={message.status} />
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Created On:
              </Typography>
              <Typography>
                {new Date(message.createdOn).toLocaleString()}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Updated On:
              </Typography>
              <Typography>
                {new Date(message.updatedOn).toLocaleString()}
              </Typography>
            </Grid>
            {message.errors && (
              <Grid item xs={12} sm={6}>
                <Alert severity="error">
                  <Typography variant="subtitle1" fontWeight="bold">
                    Error:
                  </Typography>
                  <Typography variant="body1">
                    {message.errors?.[0]?.title || "An error occurred."}
                    {message.errors?.[0]?.href && (
                      <>
                        {" "}
                        <a
                          href={message.errors[0].href}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#007bff",
                            textDecoration: "underline",
                          }}
                        >
                          Learn more
                        </a>
                      </>
                    )}
                  </Typography>
                </Alert>
              </Grid>
            )}
            {message.error && (
              <Grid item xs={12} sm={6}>
                <Alert severity="error">
                  <Typography variant="subtitle1" fontWeight="bold">
                    Error:
                  </Typography>
                  <Typography variant="body1">
                    {message.error || "An error occurred."}
                  </Typography>
                </Alert>
              </Grid>
            )}
          </Grid>
          {
            <Box mt={2} display={"flex"} justifyContent={"end"}>
              <a
                href={`/home/${id}/${message?.cusId}/message-debug-detail`}
                target="_blank"
              >
                <GlassButton>Go to debug curl</GlassButton>
              </a>
            </Box>
          }

          {/* {message.status === "queued" && (
            <Box display={"flex"} justifyContent={"end"}>
              <LoadingButton
                loading={retrying}
                variant="contained"
                onClick={handleRetryQueued}
              >
                Retry Message
              </LoadingButton>
            </Box>
          )} */}
        </Paper>
      </Container>
    </Container>
  );
};

export default RdMessageDetail;
